import { render, staticRenderFns } from "./ComitenteInput.vue?vue&type=template&id=4fb69998&"
import script from "./ComitenteInput.vue?vue&type=script&lang=js&"
export * from "./ComitenteInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports